import type { ReactElement } from 'react';
import type { MediaDto } from '@gr/core/content/media/dto';
import { useT } from '../../../../app/di';
import { formatDateTime, formatFileSize } from '../../../../shared/format';
import styles from './MediaFacts.module.scss';

/** MED-UC-3: сведения о файле; время — в поясе блога. */
export function MediaFacts({ media, timezone }: { media: MediaDto & { hasRendition: boolean }; timezone: string }): ReactElement {
  const { t, locale } = useT();
  const facts: [string, string][] = [
    [t('media.card.originalName'), media.originalName],
    [t('media.card.type'), media.mimeType],
    [t('media.card.size'), formatFileSize(media.size, locale)],
  ];
  if (media.width && media.height) facts.push([t('media.card.dimensions'), `${media.width} × ${media.height}`]);
  if (media.durationSec) facts.push([t('media.card.duration'), t('media.card.seconds', { n: media.durationSec })]);
  if (media.takenAt) facts.push([t('media.card.takenAt'), formatDateTime(media.takenAt, locale, timezone)]);
  facts.push([t('media.card.uploadedAt'), formatDateTime(media.createdAt, locale, timezone)]);
  if (media.hasRendition) facts.push([t('media.card.rendition'), t('media.card.renditionYes')]);
  // MED-RULE-5: сколько медиа занимает со всеми файлами; MED-UC-3: из чего пережато (MED-UC-9).
  if (media.storedBytes > media.size) {
    facts.push([t('media.card.stored'), t(media.hasRendition ? 'media.card.storedWithCopy' : 'media.card.storedWithPreview', { size: formatFileSize(media.storedBytes, locale) })]);
  }
  if (media.recompressed) {
    const { fromExt, fromSize, at } = media.recompressed;
    facts.push([t('media.card.recompressed'), t('media.card.recompressedValue', { ext: fromExt.toUpperCase(), size: formatFileSize(fromSize, locale), at: formatDateTime(at, locale, timezone) })]);
  }
  return (
    <dl className={styles.facts}>
      {facts.map(([term, value]) => (
        <div key={term} className={styles.fact}>
          <dt>{term}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}
